export const comments_5086240 = {"data":{"data":[],"links":{}}}